exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".semiPieChart[data-v-5f87015b]{width:100%;height:500px}", ""]);

// exports
